import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withViewTransitions, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { ApolloLink, InMemoryCache } from '@apollo/client';
import { HttpLink } from 'apollo-angular/http';

import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';

import { provideApollo } from 'apollo-angular';
import { environment } from '../environments/environment';
import { loaderInterceptor } from './middleware/interceptors/loader-interceptor-interceptor';
import { authInterceptor } from './middleware/interceptors/auth.interceptor';
import { customizedAura } from './preset.configs';
import { TranslationService } from './services/translation.service';
import { catchError, throwError, timeout } from 'rxjs';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withViewTransitions(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
    ),

    //Translation Services
    provideAppInitializer(() => {
      const translationService = inject(TranslationService);
      return translationService.init();
    }),

    //Prime NG Configurations
    providePrimeNG({
      theme: { preset: customizedAura, options: { darkModeSelector: false } },
    }),

    //Message service added Globally
    MessageService,

    provideHttpClient(withInterceptors([authInterceptor, loaderInterceptor])),
    provideApollo(() => {
      const httpLink = inject(HttpLink);

      const TIMEOUT_MS = 30000;

      const timeoutLink = new ApolloLink((operation, forward) => {
        // forward is guaranteed to exist
        return forward(operation).pipe(
          timeout(TIMEOUT_MS),
          catchError((err) => {
            if (err.name === 'TimeoutError') {
              // Mark this operation as handled
              operation.setContext({ timeoutHandled: true });

              // Throw custom error
              return throwError(
                () => new Error(`Request timed out after ${TIMEOUT_MS / 1000}s. Please try again.`),
              );
            }
            return throwError(() => err);
          }),
        );
      });

      // Combine timeout + HTTP link
      const link = ApolloLink.from([timeoutLink, httpLink.create({ uri: environment.SERVER_URL })]);

      return {
        link,
        cache: new InMemoryCache(),
      };
    }),
  ],
};
